import { AuthWebConfig } from '@auspost/auth0-uiim-types';

import { config } from 'config/env-config';
import { EnhancedWindow } from 'models/Window';

type AuthEnvType = 'prod' | 'sandbox' | 'vtest' | 'stest' | 'ptest' | 'dev' | 'playpen' | 'localhost';

const authWebConfigs: AuthWebConfig = {
  audience: config.auth0.audience,
  clientId: config.auth0.clientId,
  env: config.auth0.env as AuthEnvType,
  redirectUrl: config.auth0.redirectUrl,
  caller: 'TRACK',
  product: 'MYPOST_CONSUMER',
  channel: 'WEB',
  auth0SessionRequired: true,
  cssoSessionConfig: {
    skipCheck: true,
    skipExchange: true,
    skipRefresh: true,
  },
};

const local = {
  ...authWebConfigs,
  stubDomain: `localhost:4000`,
  stubApiBaseUrl: `http://localhost:4000`,
};

export const auth0Config: AuthWebConfig = process.env.NODE_ENV === 'development' ? local : authWebConfigs;

const eWindow = window as EnhancedWindow;
export const authService = eWindow.__AUSPOST__?.createAuthWebService && eWindow.__AUSPOST__.createAuthWebService();
export default { authService };
